import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Verified",
  "use": "icon-Verified-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-Verified\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2.76 3.829c-.464.22-.76.69-.76 1.204v5.935c0 .514.296.983.76 1.204l4.667 2.222c.362.173.784.173 1.146 0l4.667-2.222c.464-.221.76-.69.76-1.204V5.033c0-.515-.296-.983-.76-1.204L8.573 1.607a1.333 1.333 0 0 0-1.146 0L2.76 3.829Zm8.71 2.475a.665.665 0 1 0-.94-.94L7 8.893l-1.53-1.53a.665.665 0 1 0-.94.94l2 2c.26.26.68.26.94 0l4-4Z\" fill=\"#A0B4D6\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol